import Header from '../components/Header';
import Components from '../components/Components';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const ComponentsPage = () => {
  return (
    <>
      <Header />
      <div style={{marginTop: '64px'}}>
        <Components />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default ComponentsPage;
